Vue.component('ack-product-collateral-icons', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-product-collateral-icons',
	props: {
		iconItems: {
			// :product-info
			type: Array,
			required: true,
		},
	},
	computed: {
		...Vuex.mapGetters('localization', ['isUS_CA', 'isIndia', 'isAU_NZ', 'isEurope', 'isUkGb']), //isStoreAvailable
		...Vuex.mapGetters('shop', ['isStoreAvailable']),

		itemsWithAvailability() {
			return this.iconItems.map((m) => {
				let item = m;

				if (item.onlyIfStoreAvailable == true) {
					if (this.isStoreAvailable) {
						item.isAvailable = true;
					} else {
						item.isAvailable = false;
					}
				} else {
					item.isAvailable = true;
				}

				return item;
			});
		},
		isCountryWithConcierge() {
			return this.isUS_CA || this.isIndia || this.isAU_NZ || (this.isEurope && !this.isUkGb);
		},
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])
		setUserGuideLink(item) {
			if (item.link_with_concierge !== undefined) {
				return this.isCountryWithConcierge && item.link_with_concierge
					? item.link_with_concierge
					: item.link;
			} else {
				return this.isUS_CA && item.link_US_CA ? item.link_US_CA : item.link;
			}
		},
		isUserGuideLinkDisabled(item) {
			if (item.link_with_concierge !== undefined) {
				return !(this.isCountryWithConcierge && item.link_with_concierge) && !item.link;
			} else {
				return !(this.isUS_CA && item.link_US_CA) && !item.link;
			}
		},
	},
	beforeDestroy() {},
	watch: {
		isMobile: {
			handler() {},
			deep: false,
		},
	},
});
